import ReactDOM from 'react-dom/client';

import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';

import '@spotify/confidence-dev-instrumentation/bootstrap';

import app from './App';
import './bootstrap';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
